import { render, staticRenderFns } from "./SpecialDataManagement.vue?vue&type=template&id=31d6181e&"
import script from "./SpecialDataManagement.vue?vue&type=script&lang=ts&"
export * from "./SpecialDataManagement.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialDataManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports